export const GAME_TITLE = 'Bardle';
export const SAVE_GAME_KEY = 'bardle-game';
export const THEME_KEY = 'bardle-theme';
export const STATS_KEY = 'bardle-stats';
export const DEFAULT_SQUARE_LIGHT = '⬜';
export const DEFAULT_SQUARE_DARK = '⬛';
export const CORRECT_SQUARE = '🟩';
export const PRESENT_SQUARE = '🟨';
export const ERROR_MSG_INSUFFICIENT_LETTERS = 'Not enough letters';
export const ERROR_MSG_INVALID_WORD = 'Invalid word';
export const GAME_OVER_MESSAGE_WIN = 'Congratulations!';
export const GAME_OVER_MESSAGE_LOSE = 'Oh no!';
export const SHARE_BUTTON_TEXT = 'Share';
export const COPY_BUTTON_TEXT = 'Copy to clipboard';

/* 
* Take care when changing the below - search for uses in *.test.js and *.scss files first
*/
export const DEFAULT_STATUS = 'default';
export const CORRECT_STATUS = 'hamlet';
export const PRESENT_STATUS = 'juliet';
export const ABSENT_STATUS = 'iago';
export const WINNING_STATUS = 'bardle';
export const FILLED_STATUS = 'falstaff';
